export function playAnimation(element, keyframes, options) {
    if (!(element instanceof HTMLElement) || typeof element.animate !== 'function') {
        return null;
    }

    try {
        const animation = element.animate(keyframes, options);
        if (animation === null || typeof animation.cancel !== 'function') {
            return null;
        }

        return animation;
    } catch (_error) {
        return null;
    }
}

export function cancelAnimations(animations) {
    animations.forEach((animation) => {
        if (animation && typeof animation.cancel === 'function') {
            animation.cancel();
        }
    });
}

export async function settleAnimations(animations) {
    await Promise.allSettled(animations.map((animation) => {
        if (!animation) {
            return Promise.resolve();
        }

        if (typeof animation.finished?.then !== 'function') {
            animation.cancel?.();
            return Promise.resolve();
        }

        return animation.finished;
    }));
}
